<template>
  <v-page page="bcmTaskProfile">
    <v-container fluid ma-5>
      <v-row no-gutters justify="center">
        <v-col cols="4" xs="12" sm="12" md="10" lg="6">
          <!-- BREADCRUMB -->
          <v-row dense>
            <v-col>
              <v-card flat>
                <v-breadcrumbs :items="breadcrumb">
                  <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                  </template>
                </v-breadcrumbs>
                <v-card-text>
                  <disclaimer-panel>
                    <template v-slot:title>
                      This page is not fully featured yet, click to see more.
                    </template>
                    <template v-slot:content>
                      Not implemented yet (*):
                      <ul>
                        <li>Task deletion (no API endpoint exists yet)</li>
                        <li>Models tab</li>
                        <li>Change history tab</li>
                      </ul>
                    </template>
                  </disclaimer-panel>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- TITLE -->
          <v-row dense justify="center">
            <v-col>
              <v-card flat>
                <v-card-title class="text-h4">Task Profile</v-card-title>
                <v-card-text class="text-h5">{{
                  taskDetails.name
                }}</v-card-text>
                <v-divider />
              </v-card>
            </v-col>
          </v-row>

          <!-- TABS -->
          <v-row>
            <v-col>
              <v-card flat>
                <v-tabs v-model="tabs" centered>
                  <v-tab v-for="tabName in tabNames" :key="tabName">{{
                    tabName
                  }}</v-tab>
                </v-tabs>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-tabs-items v-model="tabs">
                <!-- OVERVIEW TAB -->
                <v-tab-item>
                  <overview-tab :taskDetails="taskDetails"></overview-tab>
                </v-tab-item>
                <!-- ITEMS TAB -->
                <v-tab-item>
                  <items-tab :id="id" :tasks="tasks"></items-tab>
                </v-tab-item>
                <!-- Q-MATRICES TAB -->
                <v-tab-item>
                  <matrices-tab :qMatrixDetails="qMatrixDetails"></matrices-tab>
                </v-tab-item>
                <!-- MODELS TAB -->
                <v-tab-item>
                  <models-tab :id="id" :models="models"></models-tab>
                </v-tab-item>
                <!-- CHANGELOG TAB -->
                <v-tab-item>
                  <changelog-tab></changelog-tab>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'
import OverviewTab from '../components/tasks/profile/OverviewTab.vue'
import ItemsTab from '../components/tasks/profile/ItemsTab.vue'
import DisclaimerPanel from '../UI/DisclaimerPanel.vue'
import MatricesTab from '../components/tasks/profile/MatricesTab.vue'
import ModelsTab from '../components/tasks/profile/ModelsTab.vue'

export default {
  name: 'bcmTaskProfile',
  components: {
    VPage,
    ItemsTab,
    OverviewTab,
    DisclaimerPanel,
    MatricesTab,
    ModelsTab
  },
  props: {
    id: String
  },
  data () {
    return {
      isEditing: false,
      tabNames: ['Overview', 'Items', 'Q-Matrices', 'Models', 'Change History'],
      tabs: null,
      tasks: [],
      taskDetails: {},
      qMatrices: [],
      qMatrixDetails: [],
      models: [],
      breadcrumb: [
        {
          text: 'Explore',
          disabled: false,
          exact: true,
          to: '/bcm'
        },
        {
          text: 'Tasks',
          disabled: false,
          exact: true,
          to: '/bcm/tasks'
        },
        {
          text: 'Profile',
          disabled: false
        }
      ]
    }
  },
  async created () {
    await this.initialize()
  },
  methods: {
    async initialize () {
      await this.getTasks()
      await this.getQMatrices()
      await this.getModels()
      await this.getTaskDetails()
      await this.getQMatrixDetails()
    },
    async getTasks () {
      try {
        this.tasks = await this.$store.dispatch(
          'bcm/fetchBlueprintTasks',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: 'Failed to retrieve Blueprint Content Manager Tasks'
        })
      }
    },
    async getQMatrices () {
      try {
        this.qMatrices = await this.$store.dispatch(
          'bcm/fetchQMatrices',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: `Failed to retrieve Blueprint Content Manager Q-Matrices`
        })
      }
    },
    async getModels () {
      try {
        this.models = await this.$store.dispatch(
          'bcm/fetchModels',
          this.attribute ? { type: this.attribute, values: this.query } : null
        )
      } catch (err) {
        Bus.$emit('alert', {
          color: 'error',
          message: `Failed to retrieve Blueprint Content Manager Models`
        })
      }
    },
    async getTaskDetails () {
      this.taskDetails = await this.tasks.find(
        (task) => parseInt(task.id) === parseInt(this.id)
      )
    },
    async getQMatrixDetails () {
      this.qMatrixDetails = await this.qMatrices.filter(
        (matrix) => parseInt(matrix.task_id) === parseInt(this.id)
      )
    }
  }
}
</script>
